import { render, staticRenderFns } from "./Labels.vue?vue&type=template&id=77bb7f4c&scoped=true"
import script from "./Labels.vue?vue&type=script&lang=js"
export * from "./Labels.vue?vue&type=script&lang=js"
import style0 from "./Labels.vue?vue&type=style&index=0&id=77bb7f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb7f4c",
  null
  
)

export default component.exports